module.exports = __webpack_public_path__ + "post-listing-block-3-overlay-wide@2x-2XsSChX.png";